/**
 * Las pestañas de Ajustes, en un solo lugar.
 *
 * Existe por un bug real (2026-09-09): Ajustes se reestructuró a seis pestañas
 * y cuatro mensajes de la interfaz siguieron nombrando pestañas viejas. El peor
 * fue el de facturación — "Create an account in Settings → Billing first"
 * cuando no hay ninguna pestaña Billing —, que mandó a un cliente a buscar algo
 * que no existe.
 *
 * La regla que sale de eso: **ningún texto nombra una pestaña**. El nombre sale
 * de `settings.tabs6.<id>` y el destino de `settingsTabPath(id)`; renombrar o
 * mover una pestaña arrastra los dos. `settingsTabs.test.ts` falla si alguna
 * cadena vuelve a escribir el nombre a mano.
 */
export const SETTINGS_TABS = ['account', 'brand', 'channels', 'automation', 'data', 'system'] as const;

export type SettingsTabId = (typeof SETTINGS_TABS)[number];

/** Clave i18n del nombre visible de la pestaña. */
export function settingsTabLabelKey(tab: SettingsTabId): string {
  return `settings.tabs6.${tab}`;
}

/**
 * Ruta que abre Ajustes en esa pestaña. 'account' es el default de
 * `useTabParam`, así que no ensucia la URL con el parámetro.
 */
export function settingsTabPath(tab: SettingsTabId): string {
  return tab === 'account' ? '/settings' : `/settings?tab=${tab}`;
}
